import { apiAuthed } from "./api";

/** The signed-in customer's welcome coupon (issued by the backend on first request). */
export interface WelcomeCoupon {
  code: string;
  amountOffInr: number;
  minOrderInr: number;
  freeDelivery: boolean;
  redeemed: boolean;
}

export const fetchWelcomeCoupon = () => apiAuthed<WelcomeCoupon>("GET", "/me/welcome-coupon");

export const redeemWelcomeCoupon = (code: string) =>
  apiAuthed<{ redeemed: boolean }>("POST", "/me/welcome-coupon/redeem", { code });
